import helpers_utm_keys from "~/helpers/signup/utmKeys.js"


export default function () {
    const payload = {
        event_type: "signup",
        referer: this.$cookies.get("referer"),
        ...helpers_utm_keys.reduce((accumulator, utmKey) => {
            const cookieValue = this.$cookies.get(utmKey)

            if (typeof cookieValue === "string")
                accumulator[utmKey] = cookieValue
            return accumulator
        }, {})
    }
    this.$axios
        .$post("/tracking/event/", payload, {})

}
